import Vue from 'vue'
import Vuex from 'vuex'

import data from './data'
import disclaimers from './disclaimers'

Vue.use(Vuex)

export default new Vuex.Store({

  /**
   * STATE
   * -----
   * 
   * This JSON object basically defines the initial state of the application.
   * This state can then be changed by the various functions and methods
   * throughout the application
   */

  state: {

    devMode: false,

    // App State

    app: {

      // The modal state. 
      // We'll be using the values of this state to control
      // the output of the modal window.
      modal: {

        state: false,
        component: '',

      },

      controllers: {

        tools: {

          forceClose: false,

        }

      },

      tool: false,
      report: false,
      language: document.getElementsByTagName('html')[0].getAttribute('lang'),

      print: {

        useCover: true,
        useDisclaimer: true,
        useProfile: false,
        useNetWorth: false,
        useRetirementPlanner: false,
        useGPS: false,
        useTool: false,
        useDisclaimers: true,

        useDisclaimersGlobal: true,

        useNetworthTotal: true,
        useNetworthComp: true,
        useNetworthBreakdown: false,

        useRetirementOutlook: true,
        useRetirementIncome: true,
        useRetirementBenefits: true,
        useRetirementPension: true,
        useRetirementValues: true,
        useRetirementWealthAccumulation: true,
        useRetirementWealthAccumulationGraph: true,
        useRetirementWealthAccumulationTable: true,

        useRetirementDeacumulation: true,
        useRetirementDeacumulationGraph: true,
        useRetirementDeacumulationTable: true,

        useRetirementCashflows: true,
        useRetirementCashflowsGraph: true,
        useRetirementCashflowsTable: true,

        useGPSOverview: true,
        useGPSProjections: true,
        useGPSShock: true,

        useToolChart: true,
        useToolTable: false,

        printTitle: '%n\' s Plan',
        printTitleFr: 'Analyse pour %n',
        printDisclaimer: 0,
        printLanguage: 'default',

      },

      errors: {

        '302': false,

      }

    },

    prototype: data.proto,

    // Client State
    client: false,

    // Spouse Data
    spouse: false,

    // Clients
    clientList: {},

    // Constants
    constants: {

      currentYear: false,     // Current Year
      maxOASPay: false,       // Maximum Monthly OAS Payout
      maxOASThresh: false,    // Maximum OAS income threshold
      maxCPPPay: false,       // Maxmium CPP Payout
      maxCPPThresh: false,    // Maximum CPP income Threshold
      cppBenefit: false,      // CPP Death Benefit
      survivorPension: false, // Survivor's Pension
      lifSchedule: {
        rows: [],
        total: 0,
      },
      shockEvents: {
        rows: [],
        total: 0,
      },
      printTitle: '%n\' s Plan',
      printTitleFr: 'Analyse pour %n',
      disclaimers: {
        rows: [],
        total: 0,
      },
    },

    tools: {

      savingsFuture: {
        sum: 100000,
        rate: 0.05,
        years: 25,
        depositing: 'monthly',
        contribution: 200,
      },

      investmentFuture: {
        sum: 10000,
        rate: 0.05,
        years: 25,
        depositing: 'monthly',
        contribution: 150,
      },

      regularWithdrawals: {
        sum: 100000,
        rate: 0.05,
        years: 25,
        index: 0.015,
        withdrawing: 'annual',
      },

      systematicWithdrawals: {
        sum: 100000,
        withdrawal: 550,
        rate: 0.05,
        years: 25,
        index: 0.015,
        withdrawing: 'monthly',
      },

    }

  },


  /**
   * MUTATIONS
   * ---------
   * 
   * Mutations allow us to change the overall state of the application
   * These are generally called by actions, and convention dicates
   * that they should have all capitals in their names
   */

  mutations: {

    INIT_DATA(state, vars) {

      if (vars.clients !== undefined) {

        state.clientList = vars.clients;

        for (var k in vars.constants) {

          state.constants[k] = vars.constants[k];

        }

        if (vars.constants.printTitle !== undefined) {

          if (vars.constants.printTitle !== '') {

            state.app.print.printTitle = vars.constants.printTitle + '';

          }

        }

      }

    },

    OPEN_MODAL(state, component) {

      state.app.modal.state = true;
      state.app.modal.component = component;

    },

    CLOSE_MODAL(state) {
      state.app.modal.state = false
    },

    SAVE_PRINT_OPTION(state, vars) {

      state.app.print[vars.field] = vars.value;

    },

    SET_CONTROLLER(state, vars) {

      state.app.controllers[vars.area][vars.prop] = vars.val;

    },

    SET_APP_LANGUAGE(state) {

      state.app.language = (state.app.language === 'en') ? 'fr' : 'en'
      document.getElementsByTagName('html')[0].setAttribute('lang', state.app.language)

    },

    ADD_ROW(state, vars) {

      state = window._getEmptyRow(state, vars);

    },

    REMOVE_ROW(state, vars) {

      state = window._removeRow(state, vars);

    },

    SAVE_CELL(state, vars) {

      // Use the external _saveCell function to 
      // save the value back to the state
      state = window._saveCell(state, vars);

    },

    SAVE_FIELD(state, vars) {

      state = window._saveField(state, vars);

    },

    SAVE_SETTING(state, vars) {

      state.constants[vars.field] = vars.value;

      if (vars.field === 'printTitle') {

        state.app.print.printTitle = vars.value;

      }

    },

    SAVE_TOOL_FIELD(state, vars) {

      var s = vars.field.split('.');
      state.tools[s[0]][s[1]] = vars.value;

    },

    SAVE_REPEATER(state, vars) {

      state = window._saveRepeaterData(state, vars);

    },

    NEW_CLIENT(state) {

      state.client = JSON.parse(JSON.stringify(state.prototype.client));

      state.app.print.useProfile = true;
      state.app.print.useNetWorth = true;
      state.app.print.useRetirementPlanner = true;
      state.app.print.useGPS = true;

    },

    UPDATE_CLIENT_STATE(state, client) {

      // Reset the tables when a client is loaded
      window.tables = {

        legends: {},

        netWorth: {},

        retirementSummary: {},
        wealthAccumulationData: [],
        systematicWithdrawalsData: [],
        postRetirementCashFlowData: [],

        financialGPSSummary: {},

        toolSavingsFuture: {},
        toolInvestmentFuture: {},
        toolRegularWithdrawls: {},

      }

      state.client = client;
      state.client.snapshots.current = 'current';

      state.app.print.useProfile = true;
      state.app.print.useNetWorth = true;
      state.app.print.useRetirementPlanner = true;
      state.app.print.useGPS = true;


    },

    UPDATE_CLIENT_ID(state, id) {

      state.client.id = id;

    },

    UPDATE_CLIENT_LIST_DEACTIVE(state, vars) {

      if (state.clientList[vars.id] === undefined) {
        state.clientList[vars.id] = {

          firstName: vars.firstName,
          lastName: vars.lastName,
        };

      }

      state.clientList[vars.id].deactivate = vars.deactive;

    },

    UPDATE_SPOUSE_STATE(state, spouse) {

      state.spouse = spouse;

    },

    SET_CURRENT_TOOL(state, value) {

      state.app.tool = value;

    },

    SET_CURRENT_REPORT(state, value) {

      state.app.report = value;

    },

    TAKE_CURRENT_SNAPSHOT(state, data) {

      state = window._saveSnapshot(state, data);
      state.client = window.rawObject(state.client);

    },

    SET_CURRENT_SNAPSHOT(state, data) {

      if (state.app.report === 'financialgps') {
        state.client.snapshots.gps = data.date;
      } else {
        state.client.snapshots.current = data.date;
      }

    },

    DELETE_SNAPSHOT(state, data) {

      state = window._deleteSnapshot(state, data);

    },

    UPDATE_SNAPSHOT_DATE(state, data) {

      state = window._updateSnapshotDate(state, data);

    },

    UPDATE_DEV_MODE(state, bool) {

      state.devMode = bool;

    },

  },


  /**
   * ACTIONS
   * -------
   * 
   * Actions are functions that are dispatched by components. They
   * can be used to by components to execute mutations on the state.
   * Ideally, with proper computation methods in the components,
   * this would allow for very quick updates on the View layer
   * of the application.
   */

  actions: {

    // sayHi({commit}, msg) {
    //   commit('SAY_HI', msg)
    // },

    initData({ commit }, vars) {

      commit('INIT_DATA', vars);

    },

    openModal({ commit }, component) {

      commit('OPEN_MODAL', component);

    },

    closeModal({ commit }) {

      commit('CLOSE_MODAL');

    },

    savePrintOption({ commit }, vars) {

      commit('SAVE_PRINT_OPTION', vars);

    },

    setController({ commit }, vars) {

      commit('SET_CONTROLLER', vars);

    },

    setAppLanguage({ commit }) {
      commit('SET_APP_LANGUAGE');
    },

    addRow({ commit }, vars) {
      commit('ADD_ROW', vars);
    },

    removeRow({ commit }, vars) {
      commit('REMOVE_ROW', vars);
    },

    saveCell({ commit }, vars) {
      commit('SAVE_CELL', vars);
    },

    saveField({ commit }, vars) {
      commit('SAVE_FIELD', vars);
    },

    saveSetting({ commit }, vars) {
      commit('SAVE_SETTING', vars);
    },

    saveToolField({ commit }, vars) {
      commit('SAVE_TOOL_FIELD', vars);
    },

    saveRepeater({ commit }, vars) {
      commit('SAVE_REPEATER', vars);
    },

    newClient({ commit }) {
      commit('NEW_CLIENT');
    },

    updateClientState({ commit }, client) {
      commit('UPDATE_CLIENT_STATE', client);
    },

    updateClientId({ commit }, id) {
      commit('UPDATE_CLIENT_ID', id);
    },

    updateClientListDeactivate({ commit }, vars) {
      commit('UPDATE_CLIENT_LIST_DEACTIVE', vars);
    },

    updateSpouseState({ commit }, client) {
      commit('UPDATE_SPOUSE_STATE', client);
    },

    setCurrentTool({ commit }, value) {
      commit('SET_CURRENT_TOOL', value);
    },

    setCurrentReport({ commit }, value) {
      commit('SET_CURRENT_REPORT', value);
    },

    takeCurrentSnapshot({ commit }, data) {
      commit('TAKE_CURRENT_SNAPSHOT', data);
    },

    setCurrentSnapshot({ commit }, data) {
      commit('SET_CURRENT_SNAPSHOT', data);
    },

    deleteSnapshot({ commit }, data) {
      commit('DELETE_SNAPSHOT', data);
    },

    updateSnapshotDate({ commit }, data) {
      commit('UPDATE_SNAPSHOT_DATE', data);
    },

    updateDevMode({ commit }, bool) {
      commit('UPDATE_DEV_MODE', bool);
    },

  },


  /**
   * GETTERS
   * -------
   * 
   * Getters are simple statements that allow us to fetch pieces
   * of state, allowing us to bind 
   */


  getters: {

    // App Getters
    modalState: state => state.app.modal.state,

    modalComponent: state => state.app.modal.component,

    modalVars: state => state.app.modal,

    getPrintOptions: state => state.app.print,

    getGlobalDisclaimers: state => disclaimers,

    getCurrentTool: state => state.app.tool,

    getCurrentReport: state => state.app.report,

    getCurrentLanguage: state => state.app.language,

    getCurrentSnapshot: (state) => {

      if (state.client) {
        if (state.app.report === 'financialgps') {
          return state.client.snapshots.gps;
        }
        else {
          return state.client.snapshots.current;
        }
      } else {
        return 'current';
      }

    },

    getControllers: state => state.app.controllers,

    getClientObject: state => state.client,

    errorState: state => state.app.errors,

    hasClient: (state) => () => {

      if (state.client !== false) {

        return true;

      }

      return false;

    },

    // Prototypes
    getPrototype: (state, getters) => (type, prototype) => {

      return (prototype.substr(0, 5) === 'calc.') ? getters[prototype.substr(5)]() : state.prototype[type][prototype];

    },

    getFieldData: state => (vars) => {

      return window._getFieldData(state, vars);

    },

    getSettingData: state => (vars) => {

      return state.constants[vars.field];

    },

    getToolData: state => (field) => {

      var s = field.split('.');
      return state.tools[s[0]][s[1]];

    },

    getDropdownData: (state, getters) => (vars) => {

      if (vars.proto !== undefined) {

        var calc = vars.proto.substr(5) + 'Value';
        return (vars.proto.substr(0, 5) === 'calc.') ? getters[calc]('name') : window._getDropdownData(state, vars);

      }

      return window._getDropdownData(state, vars);

    },

    getDropdownLabels: state => (vars) => {

      return state.prototype.dropdown['contributionFrequency'];

    },

    // Repeater Getters
    getRepeaterData: state => (vars) => {

      return window._getRepeaterData(state, vars);

    },

    getRepeaterTotal: state => (vars) => {

      return window._getRepeaterTotal(state, vars);

    },

    getRepeaterLastValue: state => (vars) => {

      return window._getRepeaterLastValue(state, vars);

    },

    // Client Getters

    getClientData: state => (data) => {

      return state.clientList;

    },

    getClientName: state => (data) => {

      if (!data.id) {

        return 'none';

      }

      var clientData = state.clientList[data.id],
        clientName = '';

      if (clientData.firstName !== undefined) {

        clientName += clientData.firstName;

      }

      if (clientData.lastName !== undefined) {

        clientName += ' ' + clientData.lastName;

      }

      return clientName.trim();

    },

    getCurrentClientName: state => () => {

      var clientName = '';

      if (state.client === false) {

        return 'Client';

      }

      if (state.client.details.firstName !== undefined) {

        clientName += state.client.details.firstName;

      }

      if (state.client.details.lastName !== undefined) {

        clientName += ' ' + state.client.details.lastName;

      }

      return clientName.trim();


    },

    getClientDOB: (state, getters) => () => {

      var dob = getters.getFieldData({ field: 'details.dateOfBirth' });

      dob.year = (dob.year === '0') ? '1980' : dob.year;
      dob.month = (dob.month === '0') ? '1' : dob.month;
      dob.day = (dob.day === '0') ? '1' : dob.day;

      return dob;

    },

    getClientDOBPast: (state, getters) => () => {

      var dob = getters.getClientDOB(),
        today = new Date(),

        _t = window.padDigits((today.getUTCMonth() + 1), 2) + '' + window.padDigits(today.getUTCDate(), 2),
        _b = window.padDigits(dob.month, 2) + '' + window.padDigits(dob.day, 2);

      return (_t >= _b);

    },

    getClientDOBText: (state, getters) => () => {

      var dob = getters.getFieldData({ field: 'details.dateOfBirth' }),
        months = state.prototype.dropdown.months,
        dob_string = months[Number(dob.month)] + ' ' + dob.day + ', ' + dob.year;

      return dob_string;

    },

    getClientAge: (state, getters) => () => {

      var dob = getters.getClientDOB(),
        today = new Date(),
        dob_date = new Date(dob.year, dob.month - 1, dob.day),
        age = today.getFullYear() - dob_date.getFullYear(),
        m = today.getMonth() - dob_date.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob_date.getDate())) {
        age--;
      }

      return age;

    },

    getClientStartDate: (state, getters) => (program = true) => {

      var dob = getters.getClientDOB(),
        field = 'snapshots.current';

      if (state.app.report === 'financialgps') {
        field = 'snapshots.gps';
      }

      if (program) {

        var start = new Date(Number(getters.getFieldData({ field: 'retirement.startPlan' })), Number(dob.month), Number(dob.day));

      }

      else {

        var source = getters.getFieldData({ field: field });

        if (source === 'current') {
          var start = new Date();
        }
        else {
          var start = new Date(Number(source.substr(0, 4)), Number(source.substr(4, 2)), Number(source.substr(6)));
        }

      }

      return start;

    },

    getClientCurrentAge: (state, getters) => (program = true) => {

      var dob = getters.getClientDOB(),
        dob_date = new Date(dob.year, dob.month - 1, dob.day),
        field = 'snapshots.current';

      if (state.app.report === 'financialgps') {
        field = 'snapshots.gps';
      }

      var source = getters.getFieldData({ field: field });

      if (source === 'current') {

        var today = new Date();

      }

      else {

        var today = new Date(Number(source.substr(0, 4)), Number(source.substr(4, 2)), Number(source.substr(6)));

      }


      var year = Number(today.getFullYear()),
        age = year - Number(dob.year),
        m = today.getMonth() - dob_date.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob_date.getDate())) {
        age--;
      }

      return age;

    },

    getClientCurrentToDeath: (state, getters) => (program = true) => {

      var current = getters.getClientStartAge(program),
        death = getters.getFieldData({ field: 'retirement.lifeExpectancy' });

      return death - current;

    },

    getClientStartAge: (state, getters) => (program = true) => {

      var dob = getters.getClientDOB(),
        today = new Date(),
        start = getters.getClientStartDate(program),
        dob_date = new Date(dob.year, dob.month - 1, dob.day),
        age = start.getFullYear() - dob_date.getFullYear(),
        m = start.getMonth() - dob_date.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob_date.getDate())) {
        age--;
      }

      return age;

    },

    getRetirmentAge: (state, getters) => () => {

      var useRetirementDate = getters.getFieldData({ field: 'retirement.useRetirementDate' });

      if (useRetirementDate) {

        var dob = getters.getClientDOB(),
          dob_date = new Date(dob.year, dob.month - 1, dob.day),
          //ret = getters.getFieldData({ field: 'retirement.retirementAge' }),
          ret = getters.getFieldData({ field: 'retirement.retirementDate' }),
          ret_date = new Date(ret.year, ret.month - 1, ret.day),
          ageDifMs = ret_date - dob_date,
          ageDate = new Date(ageDifMs),

          retirement = Math.abs(ageDate.getUTCFullYear() - 1970);

      } else {

        var retirement = Number(getters.getFieldData({ field: 'retirement.retirementAge' }));

      }

      return retirement;

    },

    getClientWithdrawalAge: (state, getters) => (program = true) => {

      var retirement = Number(getters.getRetirmentAge()),
        start = getters.getClientCurrentAge();

      //return (start < retirement) ? retirement : start;
      return retirement;

    },

    getClientWidrawaltoDeath: (state, getters) => (program = true) => {

      var current = getters.getClientWithdrawalAge(program),
        death = getters.getFieldData({ field: 'retirement.lifeExpectancy' });

      return death - current;

    },

    getClientRetirementYear: (state, getters) => () => {

      var dob = getters.getClientDOB(),
        retirement = getters.getRetirmentAge();

      return Number(dob.year) + Number(retirement);

    },

    getClientYearsToRetire: (state, getters) => (program = true) => {

      var dob = getters.getClientDOB(),
        start = getters.getClientStartDate(program),
        retirement_age = parseInt(getters.getRetirmentAge()),
        retirement_date = new Date(parseInt(dob.year) + retirement_age, dob.month - 1, dob.day),
        difference = retirement_date.getFullYear() - start.getFullYear(),
        m = retirement_date.getMonth() - start.getMonth();

      if (m < 0 || (m === 0 && start.getDate() < retirement_date.getDate())) {
        difference--;
      }

      return difference + 1;

    },

    getClientRetirementToDeath: (state, getters) => () => {

      var dob = getters.getClientDOB(),

        retirement_age = parseInt(getters.getRetirmentAge()),
        death_age = parseInt(getters.getFieldData({ field: 'retirement.lifeExpectancy' })),

        retirement_date = new Date(parseInt(dob.year) + retirement_age, dob.month - 1, dob.day),
        death_date = new Date(parseInt(dob.year) + death_age, dob.month - 1, dob.day),

        difference = death_date.getFullYear() - retirement_date.getFullYear(),

        m = death_date.getMonth() - retirement_date.getMonth();

      if (m < 0 || (m === 0 && death_date.getDate() < retirement_date.getDate())) {
        difference--;
      }

      return difference;

    },

    getCurrentYear: state => () => {

      var date = new Date();
      return date.getFullYear();

    },

    getIndexPercentage: (state, getters) => () => {

      return window.formatPercentage(getters.getFieldData({ field: 'retirement.inflationRate' }));

    },

    getClientSpouse: (state, getters) => () => {

      return getters.getFieldData({ field: 'details.spouse' });

    },

    getClientSpouseData: state => () => {

      return state.spouse;

    },

    getClientSpouseName: (state, getters) => () => {

      if (state.spouse) {

        return {
          firstName: state.spouse.details.firstName,
          lastName: state.spouse.details.lastName
        };

      }

      return false;

    },

    getAddressObject: (state, getters) => (vars = false) => {

      if (vars === false) {

        return false;

      }

      var addr = [],
        data = getters.getFieldData(vars),
        line = '',
        x = 0;

      if (data !== '') {

        if (data.line1.trim() !== '') {

          addr[x++] = data.line1.trim();

        }

        if (data.line2.trim() !== '') {

          addr[x++] = data.line2.trim();

        }

        if (data.line3.trim() !== '') {

          addr[x++] = data.line3.trim();

        }

        if (data.city.trim() !== '') {

          line += data.city.trim() + ' ';

        }

        if (data.province.trim() !== '') {

          line += data.province.trim();

        }

        if (data.postalcode.trim() !== '') {

          if (data.province !== '') {

            line += ', ';

          }

          line += data.postalcode + ' ';

        }

        line = line.trim();
        if (line !== '') {

          addr[x++] = line;

        }

        if (data.country.trim() !== '') {

          addr[x++] = data.country.trim();

        }

      }

      return addr;

    },

    getAddress: (state, getters) => (vars = false) => {

      if (vars === false) {

        return false;

      }

      var addr = '',
        line = '',
        data = getters.getFieldData(vars);

      if (data.line1.trim() !== '') {

        addr += data.line1 + '<br>';

      }

      if (data.line2.trim() !== '') {

        addr += data.line2 + '<br>';

      }

      if (data.line3.trim() !== '') {

        addr += data.line3 + '<br>';

      }

      if (data.city.trim() !== '') {

        line += data.city + ' ';

      }

      if (data.province.trim() !== '') {

        line += data.province;

      }

      if (data.postalcode.trim() !== '') {

        if (data.province !== '') {

          line += ', ';

        }

        line += data.postalcode + ' ';

      }

      if (data.country.trim() !== '') {

        line += '<br>';
        line += data.country;

      }

      line = line.trim();
      if (line !== '') {

        addr += line;

      }

      if (addr.trim() === '') {

        addr = '--';

      }

      return addr;

    },


    getInterestRateRequired: state => (periods, payment, present, future = 0, type = 0, guess = 0) => {

      var val = present,
        rate = guess,
        lastVal = 0,
        diff = 0,
        inc = 0;

      if (periods <= 0) {

        return 0;

      }

      var i = 0;
      // Type 0: Accumulation
      if (type === 0) {

        while (val < future && i < 10000000) {

          val = present;

          for (var x = 0; x < (periods); x++) {

            val *= (1 + rate);
            val += payment;

          }

          lastVal = val;
          diff = lastVal / future;

          if (diff < .5) {

            inc = .01;

          }

          else if (diff < .8) {

            inc = .001;

          }

          else {

            inc = .0001;

          }

          rate += inc;

          ++i;

        }

        rate -= inc;

      }

      // Type 1: De-accumulation
      else if (type === 1) {

        var rawData = window.tables.postRetirementCashFlowData;
        rate = 1;

        var i = 0;
        while (val > future && i < 10000) {

          val = present;
          var start = true;

          for (var x = 0; x < (periods + 1); x++) {

            if (start) {

              start = false;

            }

            else {

              if (x < periods) {
                val -= rawData[x - 1].required;
                val *= (1 + rate);
              }

            }


          }

          lastVal = val;
          diff = present / lastVal;

          if (diff < .5) {

            inc = .01;

          }

          else if (diff < .8) {

            inc = .001;

          }

          else {

            inc = .0001;

          }

          rate -= inc;

          ++i;

        }

        rate += inc;

        rate = (rate > 0) ? rate : 0;

      }

      return rate;

    },


    /**
     * Account Related Getters 
     *
     * These getters are used to pull key information from the client profile
     * and return variables, arrays or objects containing account information,
     * mostly for use in different reports.
     * 
     */

    getAssetsBase: (state, getters) => (v = 'balance') => {

      return {

        open_chequing: getters.getAccountBase('savings.open.chequing', v),
        open_savings: getters.getAccountBase('savings.open.savings', v),
        // open_bonds:               getters.getAccountBase('savings.open.bonds', v),
        open_stocks: getters.getAccountBase('savings.open.stocks', v),
        open_mutualFunds: getters.getAccountBase('savings.open.mutualFunds', v),
        // open_gics:                getters.getAccountBase('savings.open.gics', v),
        open_other: getters.getAccountBase('savings.open.other', v),

        open_tfsa: getters.getAccountBase('savings.open.tfsa', v),

        // registered_savings:       getters.getAccountBase('savings.registered.savings', v),
        // registered_bonds:         getters.getAccountBase('savings.registered.bonds', v),
        // registered_stocks:        getters.getAccountBase('savings.registered.stocks', v),
        registered_mutualFunds: getters.getAccountBase('savings.registered.mutualFunds', v),
        // registered_gics:          getters.getAccountBase('savings.registered.gics', v),
        registered_rrif: getters.getAccountBase('savings.registered.rrif', v),
        registered_other: getters.getAccountBase('savings.registered.other', v),
        registered_dpspEsopGrsp: getters.getAccountBase('savings.registered.dpspEsopGrsp', v),

        lockedin_lockedRrsp: getters.getAccountBase('savings.lockedin.lockedRrsp', v),
        lockedin_employerPension: getters.getAccountBase('savings.lockedin.employerPension', v),

      };

    },

    getAssetsCurrent: (state, getters) => () => {

      var rawData = getters.getAssetsBase(),
        total = 0;

      for (var x in rawData) {

        total += Number(rawData[x]);

      }

      return total;

    },

    getAssetsGrowth: (state, getters) => () => {

      return {

        open_chequing: getters.getAccountGrowth('savings.open.chequing'),
        open_savings: getters.getAccountGrowth('savings.open.savings'),
        // open_bonds:               getters.getAccountGrowth('savings.open.bonds'),
        open_stocks: getters.getAccountGrowth('savings.open.stocks'),
        open_mutualFunds: getters.getAccountGrowth('savings.open.mutualFunds'),
        // open_gics:                getters.getAccountGrowth('savings.open.gics'),
        open_other: getters.getAccountGrowth('savings.open.other'),

        open_tfsa: getters.getAccountGrowth('savings.open.tfsa'),

        // registered_savings:       getters.getAccountGrowth('savings.registered.savings'),
        // registered_bonds:         getters.getAccountGrowth('savings.registered.bonds'),
        // registered_stocks:        getters.getAccountGrowth('savings.registered.stocks'),
        registered_mutualFunds: getters.getAccountGrowth('savings.registered.mutualFunds'),
        // registered_gics:          getters.getAccountGrowth('savings.registered.gics'),
        registered_rrif: getters.getAccountGrowth('savings.registered.rrif'),
        registered_other: getters.getAccountGrowth('savings.registered.other'),
        registered_dpspEsopGrsp: getters.getAccountGrowth('savings.registered.dpspEsopGrsp'),

        lockedin_lockedRrsp: getters.getAccountGrowth('savings.lockedin.lockedRrsp'),
        lockedin_employerPension: getters.getAccountGrowth('savings.lockedin.employerPension'),

      };

    },

    getAssetsContributions: (state, getters) => () => {

      return {

        open_chequing: getters.getAccountContribution('savings.open.chequing'),
        open_savings: getters.getAccountContribution('savings.open.savings'),
        // open_bonds:               getters.getAccountContribution('savings.open.bonds'),
        open_stocks: getters.getAccountContribution('savings.open.stocks'),
        open_mutualFunds: getters.getAccountContribution('savings.open.mutualFunds'),
        // open_gics:                getters.getAccountContribution('savings.open.gics'),
        open_other: getters.getAccountContribution('savings.open.other'),

        open_tfsa: getters.getAccountContribution('savings.open.tfsa'),

        // registered_savings:       getters.getAccountContribution('savings.registered.savings'),
        // registered_bonds:         getters.getAccountContribution('savings.registered.bonds'),
        // registered_stocks:        getters.getAccountContribution('savings.registered.stocks'),
        registered_mutualFunds: getters.getAccountContribution('savings.registered.mutualFunds'),
        // registered_gics:          getters.getAccountContribution('savings.registered.gics'),
        registered_rrif: getters.getAccountContribution('savings.registered.rrif'),
        registered_other: getters.getAccountContribution('savings.registered.other'),
        registered_dpspEsopGrsp: getters.getAccountContribution('savings.registered.dpspEsopGrsp'),

        lockedin_lockedRrsp: getters.getAccountContribution('savings.lockedin.lockedRrsp'),
        lockedin_employerPension: getters.getAccountContribution('savings.lockedin.employerPension'),

      };

    },

    getAccountBase: (state, getters) => (field, v = 'balance') => {

      var accounts = getters.getRepeaterData({ field: field }),
        balance = 0;

      for (var x = 0; x < accounts.length; x++) {

        for (var y = 0; y < accounts[x].length; y++) {

          if (accounts[x][y].field === v) {

            balance += Number(accounts[x][y].value);

          }

        }

      }

      return balance;

    },

    getAccountGrowth: (state, getters) => (field, v = 'balance') => {

      var accounts_growth = [],
        accounts = getters.getRepeaterData({ field: field }),
        age = getters.getClientStartAge(),
        years = getters.getClientYearsToRetire(false),
        balance = 0,

        b = 0, // balance
        r = 0, // rate
        c = 0, // contribution
        m = false, // maturity
        f = 0;

      for (var x = 0; x < accounts.length; x++) {

        var vars = getters.getAccountProperties(accounts[x], v);

        balance = {
          val: vars.b,
          ror: vars.r,
        }

        accounts_growth[x] = [balance];

        for (var y = 1; y < years + 1; y++) {

          balance = window.rawObject(getters.getAccountGrowthLine(balance.val, vars, y));
          accounts_growth[x][y] = balance;

        }

      }

      return accounts_growth;

    },

    getAccountContribution: (state, getters) => (field) => {

      var accounts_contribution = [],
        accounts = getters.getRepeaterData({ field: field }),
        age = getters.getClientStartAge(),
        years = getters.getClientYearsToRetire(),
        total = 0;

      for (var x = 0; x < accounts.length; x++) {

        total = 0;

        if (accounts[x].length > 0) {

          var account = getters.getAccountProperties(accounts[x], 'balance'),
            c = account.c;

          if (account.f === 'bi-weekly') {

            c *= 26;

          }

          else if (account.f === 'monthly') {

            c *= 12;

          }

          else if (account.f === 'semi-monthly') {

            c *= 24;

          }

          else if (account.f === 'weekly') {

            c *= 52;

          }

          total += c;

        }

        accounts_contribution[x] = total;

      }

      return accounts_contribution;

    },

    getInitialCapital: (state, getters) => () => {

      var rawData = getters.getAssetsBase(),
        total = 0;

      for (var i in rawData) {

        total += Number(rawData[i]);

      }

      return total;

    },

    getTotalContributions: (state, getters) => () => {

      var rawData = getters.getAssetsContributions(),
        total = 0;

      for (var x in rawData) {

        if (rawData[x].length > 0) {

          for (var y = 0; y < rawData[x].length; y++) {

            total += Number(rawData[x][y]);

          }

        }

      }

      return total;

    },

    getRetirementCapitalAvailable: (state, getters) => (exclude = false) => {

      var rawData = getters.getAssetsGrowth(),
        total = 0,
        skipable = [
          'realestate_home',
          'realestate_other',
          'other_businessInterests',
          'other_other',
        ];

      for (var i in rawData) {

        var skip = false;

        if (exclude) {

          for (var x = 0; x < skipable.length; x++) {

            if (skipable[x] === i) {

              skip = true;

            }

          }

        }

        if (rawData[i].length > 0 && !skip) {

          for (var x = 0; x < rawData[i].length; x++) {

            var n = rawData[i][x].length - 1;
            total += rawData[i][x][n].val;

          }

        }

      }

      return total;

    },

    getAccountGrowthLine: (state, getters) => (balance, vars, y) => {

      var contribution = vars.c;

      if (vars.f === 'bi-weekly') {

        contribution *= 26;

      }
      else if (vars.f === 'semi-monthly') {

        contribution *= 24;

      }
      else if (vars.f === 'monthly') {

        contribution *= 12;

      }
      else if (vars.f === 'weekly') {

        contribution *= 52;

      }

      if (vars.m === false || y < vars.m) {

        // t = total
        var i = (balance * vars.r);
        var t = balance + i + contribution;
        return {
          val: Number(t.toFixed(2)),
          ror: i / balance,
        }

      }

      else {

        return Number(balance.toFixed(2));

      }

    },

    getAccountProperties: state => (account, v) => {

      var vars = {
        b: 0,      // balance
        r: 0,      // rate
        c: 0,      // contribution
        m: false,  // maturity
        f: '',     // frequency
        a: false,  // age
      }

      for (var y = 1; y < account.length; y++) {

        if (account[y].field === v) {
          vars.b = Number(account[y].value);
        }

        if (account[y].field === 'rate') {
          vars.r = Number(account[y].value);
        }

        if (account[y].field === 'contribution') {
          vars.c = Number(account[y].value);
        }

        if (account[y].field === 'maturity') {
          vars.m = Number(account[y].value);
        }

        if (account[y].field === 'frequency') {
          vars.f = account[y].value;
        }

        if (account[y].field === 'startingAge') {
          vars.a = account[y].value;
        }

      }

      return vars;

    },

    getRetirmentCapitalRequired: (state, getters) => () => {

      var byYear = getters.getRetirementIncomeRequiredByYear(),
        required = 0;

      for (var x in byYear) {

        required += byYear[x];
        required -= getters.getCppPayout(x);
        required -= getters.getOasPayout(x);
        required -= getters.getPensionPayout(x);

      }

      return (required > 0) ? required.toFixed(2) : '0.00';

    },

    getRetirementIncomeRequiredByYear: (state, getters) => () => {

      var incomeR = Number(getters.getFieldData({ field: 'retirement.requiredAtRetirement' })),
        incomeP = Number(getters.getFieldData({ field: 'retirement.passiveIncomeRequired' })),

        income = Number(getters.getFieldData({ field: 'income.presentIncome' })),

        inflate = Number(getters.getFieldData({ field: 'retirement.inflationRate' })),

        age = Number(getters.getRetirmentAge()),
        ageR = Number(getters.getRetirmentAge()),
        ageP = Number(getters.getFieldData({ field: 'retirement.passiveRetirementAge' })),
        ageD = Number(getters.getFieldData({ field: 'retirement.lifeExpectancy' })),

        required = {};

      if (age === ageR) {

        age -= 1;

      }

      for (var x = age + 1; x < ageD; x++) {

        income *= (1 + inflate);

        if (x >= ageR) {

          required[x] = (x >= ageP) ? income * (incomeP * incomeR) : income * incomeR;

        }

      }

      return required;

    },

    getAdjustmentValues: (state, getters) => (withdrawals = false) => {

      var field = (withdrawals) ? 'retirement.adjustedWithdrawals' : 'retirement.adjustedContributions',
        valueField = (withdrawals) ? 'withdrawal' : 'contribution';

      var rawData = getters.getRepeaterData({ field: field }),
        data = {};

      for (var x = 0; x < rawData.length; x++) {

        var k, v;

        for (var y = 0; y < rawData[x].length; y++) {
          if (rawData[x][y].field === 'year') {
            k = rawData[x][y].value
          }
          if (rawData[x][y].field === valueField) {
            v = rawData[x][y].value
          }
        }

        data[k] = Number(v);

      }

      return data;

    },


    /**
     * De-accumulation
     */

    getDecumulationsOrder: (state, getters) => () => {

      var order_string = getters.getFieldData({ field: 'retirement.withdrawalOrder' }),
        order = order_string.split('_'),
        decumulations = {};

      for (var x = 0; x < order.length; x++) {

        if (order[x] === 'l') {
          decumulations['lockedin_lockedRrsp'] = 'lockedin';
          decumulations['lockedin_employerPension'] = 'lockedin';
        }

        else if (order[x] === 't') {
          decumulations['open_tfsa'] = 'tfsa';
        }

        else if (order[x] === 'r') {
          decumulations['registered_dpspEsopGrsp'] = 'rrsp';
          // decumulations['registered_savings']     = 'rrsp';
          decumulations['registered_rrif'] = 'rrsp';
          // decumulations['registered_bonds']       = 'rrsp';
          // decumulations['registered_stocks']      = 'rrsp';
          decumulations['registered_mutualFunds'] = 'rrsp';
          // decumulations['registered_gics']        = 'rrsp';
          decumulations['registered_other'] = 'rrsp';
        }

        else if (order[x] === 's') {
          // decumulations['open_bonds']       = 'savings';
          decumulations['open_stocks'] = 'savings';
          decumulations['open_mutualFunds'] = 'savings';
          // decumulations['open_gics']        = 'savings';
          decumulations['open_other'] = 'savings';
          decumulations['open_savings'] = 'savings';
          decumulations['open_chequing'] = 'savings';
        }

      }

      return decumulations;

    },

    /**
     * OAS, CPP and Pension related functions
     */

    getMaxOASPayout: (state, getters) => (projected = false) => {

      var payout = Number(state.constants.maxOASPay) * 12;

      if (projected) {

        var years = Number(getters.getClientYearsToRetire(false)),
          i = Number(getters.getFieldData({ field: 'retirement.inflationRate' }));

        for (var x = 0; x <= years; x++) {

          payout *= (1 + i);

        }

        payout = payout;

      }

      return payout;

    },


    /** 
     * GETTER: getOasPayout
     * @param  {state} state    
     * @param  {getters} getters)
     * @param  {[type]} age) [description]
     * @return {[type]}          [description]
     *
     * This getter function is used to get the projected OAS Payout for a particular
     * year, based on the supplied age. 
     */
    getOasPayout: (state, getters) => (age = false) => {

      // Get the age to start the OAS payout
      var oasStart = getters.getFieldData({ field: 'retirement.oasAtAge' });

      // OAS eligibility does not start until age 65,
      // If the supplied age is less than 66, return a zero value.
      if (age < oasStart ||
        age < 65) {

        return 0;

      }

      var max = getters.getMaxOASPayout(),
        use_custom = getters.getFieldData({ field: 'retirement.oasCustomValue' }),

        payout = (use_custom === 'true') ? getters.getFieldData({ field: 'retirement.oasValue' }) : Number(state.constants.maxOASPay),
        years = (age !== false) ? Number(age - getters.getClientStartAge(false) - 1) : Number(years = getters.getClientYearsToRetire(false)),

        i = Number(getters.getFieldData({ field: 'retirement.oasIndex' }));

      payout = payout * 12;

      if (oasStart > 65 && !use_custom) {

        var maxCppAge = (oasStart >= 70) ? 70 : oasStart,
          diff = maxCppAge - 65,
          increase = (0.006 * 12) * diff;

        payout += payout * increase;

      }

      //if using custom value , shotern the loop to the amout of years till user's retirement
      if (use_custom) {
        var x = getters.getClientYearsToRetire(false)
        for (x; x <= years; x++) {
          payout *= (1 + i);
        }
      } else {
        for (var x = 0; x <= years; x++) {
          payout *= (1 + i);
        }
      }

      return payout;

    },

    getMaxCPPPayout: (state, getters) => () => {

      var payout = Number(state.constants.maxCPPPay) * 12;

      return payout;

    },


    /**
     * Function: getCppPayout()
     *
     * This function  is used to get the CPP Payout for a given year, based on the 
     * constants and the information provided in the client profile.
     * 
     * @param  {Boolean/Number} age - passes the age at which we are supposed to get the CPP Payout
     * 
     * @return {Number} returns the total CPP calculated for a given year.
     */
    getCppPayout: (state, getters) => (age = false, reduct = false) => {

      var cppStart = getters.getFieldData({ field: 'retirement.cppAtAge' });
      console.log("age", age);
      // If CPP doesn't apply, based on age, return 0
      if (age < cppStart ||
        age < 60) {

        return 0;

      }

      var max = Number(state.constants.maxCPPThresh),
        use_custom = getters.getFieldData({ field: 'retirement.cppCustomValue' }),

        payout = (use_custom === 'true') ? Number(getters.getFieldData({ field: 'retirement.cppValue' })) : Number(state.constants.maxCPPPay),
        income = Number(getters.getFieldData({ field: 'income.presentIncome' })),
        years = (age !== false) ? Number(age - getters.getClientStartAge(false) - 1) : Number(years = getters.getClientYearsToRetire(false)),

        i = Number(getters.getFieldData({ field: 'retirement.cppIndex' }));



      if (income > max) {

        payout = payout * 12;

      }

      else {

        payout = income / max * payout * 12;

      }

      // Decrease for early withdrawal of CPP
      if (cppStart < 65 && !use_custom) {

        var diff = 65 - cppStart,
          decrease = (0.006 * 12) * diff;

        if (reduct) {

          return payout * decrease;

        }

        payout -= payout * decrease;

      }

      // Increase for later withdrawal of CPP
      else if (cppStart > 65 && !use_custom) {

        var maxCppAge = (cppStart >= 70) ? 70 : cppStart,
          diff = maxCppAge - 65,
          increase = (0.007 * 12) * diff;

        payout += payout * increase;

      }

      //if using custom value , shotern the loop to the amout of years till user's retirement
      if (use_custom) {
        var x = getters.getClientYearsToRetire(false)
        for (x; x <= years; x++) {
          payout *= (1 + i);
        }
      } else {
        for (var x = 0; x <= years; x++) {
          payout *= (1 + i);
        }
      }
      return payout;

    },

    getPensionPayout: (state, getters) => (age = false) => {

      var pensionStart = Number(getters.getFieldData({ field: 'retirement.pensionAge' })),
        cppIntegrate = getters.getFieldData({ field: 'retirement.cppIntegrate' }),
        bridgeBenefit = getters.getFieldData({ field: 'retirement.hasBridgeBenefit' }),
        bridgePayout = 0,

        i = Number(getters.getFieldData({ field: 'retirement.pensionIndex' }));

      if (age < pensionStart) {
        return 0;
      }

      if (cppIntegrate === 'true') {

        var cppStart = Number(getters.getFieldData({ field: 'retirement.cppAtAge' }));

        if (cppStart < 65 && age < pensionStart) {

          bridgePayout += getters.getCppPayout(age, true);

        }

      }

      if (bridgeBenefit === 'true') {

        var bridgeStart = Number(getters.getFieldData({ field: 'retirement.bridgeStart' })),
          bridgeEnd = Number(getters.getFieldData({ field: 'retirement.bridgeEnd' }));

        if (age >= bridgeStart && age <= bridgeEnd) {

          var bridgeValue = Number(getters.getFieldData({ field: 'retirement.bridgeValue' })),
            bridgeDuration = bridgeEnd - bridgeStart;

          bridgePayout += bridgeValue * 12;

          for (var x = 0; x <= (age - (bridgeEnd - bridgeDuration)); x++) {

            bridgePayout *= (1 + i);

          }

        }


      }

      if (bridgePayout > 0 && age < pensionStart) {

        return bridgePayout;

      }

      // if ( age < pensionStart ) {

      //   return 0;

      // }    

      var payout = Number(getters.getFieldData({ field: 'retirement.pensionBenefit' })),
        years = (age === false) ? 1 : Number(age - pensionStart);

      payout *= 12;

      for (var x = 0; x < years; x++) {

        if (years > 0) {

          payout *= (1 + i);

        }

      }


      return payout + bridgePayout;

    },

    getOtherIncome: (state, getters) => () => {

      return getters.getFieldData({ field: 'income.otherSources' });

    },



    /**
     * Constants from State
     *
     * These getters return the 
     * 
     */

    getConstants: state => () => {

      return state.constants;

    },

    getAllData: state => () => {

      return state.client;

    },


    // Constants

    getDisclaimer: state => () => {

      return 'This is an illustration and not a statement. The figures described in this illustration should not be interpreted as your accurate account values with Rose &amp; Associates or any other financial institution. Illustrated returns are not guaranteed; past performance of any security is not indicative of future performance. Commissions, trailing commissions, management fees and expenses all may be associated with mutual fund investments. Please read the simplified prospectus or Fund Facts before investing. This illustration is not complete without all pages.';

    },

    getDevMode: state => () => {

      return state.devMode;

    },


    // Calculation Getters

    speculativeGrowth: function (state, getters) {

      var val = 0;

      if (state.client !== false) {
        val = 1 - getters.getFieldData({ field: 'income.targetIncome' }) - getters.getFieldData({ field: 'income.targetGrowth' });
      }

      return val.toFixed(4);

    },

    fromRegistered: function (state, getters) {

      var val = 0;

      if (state.client !== false) {
        var val = 1 - state.client.retirement.fromSavings - state.client.retirement.fromLockedin - state.client.retirement.fromTfsa;
      }

      return val.toFixed(4);

    },

    disclaimers: (state, getters) => () => {

      var constants = getters.getConstants(),
        disclaimers = {},
        k = '',
        v = '',
        i = 0;

      for (var x = 0; x < constants.disclaimers.rows.length; x++) {

        k = '';
        v = '';

        for (var y = 0; y < constants.disclaimers.rows[x].length; y++) {

          switch (constants.disclaimers.rows[x][y].field) {

            case 'name':
              k = constants.disclaimers.rows[x][y].value;
              break;

            case 'text':
              v = constants.disclaimers.rows[x][y].value;
              break;

          }

        }

        if (k !== '' && v !== '') {

          disclaimers[i] = k;
          i += 1;

        }

      }

      return disclaimers;

    },

    disclaimersValue: (state, getters) => (field = 'name') => {

      var val = '',
        constants = getters.getConstants(),
        k = state.app.print.printDisclaimer;

      for (var y = 0; y < constants.disclaimers.rows[k].length; y++) {

        if (constants.disclaimers.rows[k][y].field === field) {

          val = constants.disclaimers.rows[k][y].value;

        }

      }

      return val;

    },

    language: (state, getters) => () => {

      return {

        'en': 'English',
        'fr': 'Français'

      };

    },

    languageValue: (state, getters) => (field = 'name') => {

      var proto = getters.language(),
        lang = state.app.print.printLanguage;

      if (lang === 'default') {
        lang = state.app.language;
      }


      return proto[lang];

    },

    agePeriods: (state, getters) => () => {

      var start, end, age;

      start = Number(getters.getFieldData({ field: 'retirement.startPlan' }));
      end = Number(getters.getClientRetirementYear());
      age = Number(getters.getClientStartAge(true));

      var values = {}

      for (var x = start; x <= end; x++) {
        values['_' + x] = age++;
      }

      return values;

    },

    ageWithdrawalPeriods: (state, getters) => () => {

      var start, span, end, age;

      start = Number(getters.getClientRetirementYear());
      span = Number(getters.getClientWidrawaltoDeath());
      end = start + span;
      age = Number(getters.getClientWithdrawalAge(true));

      var values = {}

      for (var x = start; x <= end; x++) {
        values['_' + x] = age++;
      }

      return values;

    },

    // Autofill Getters

    autofillValueTotals: (state, getters) => () => {

      var row = [],
        today = new Date();

      row[0] = {
        field: 'month',
        type: 'dropdown',
        value: today.getMonth() + '',
      }

      row[1] = {
        field: 'year',
        type: 'dropdown',
        value: today.getFullYear() + '',
      }

      row[2] = {
        field: 'balance',
        type: 'currency',
        value: getters.getAssetsCurrent(),
      }

      return row;

    },

  }

});



// WEBPACK FOOTER //
// ./src/vuex/store.js